// extracted by mini-css-extract-plugin
export default {"splashStyle":"Launch_splashStyle__LhIyF"};